import Vue from "vue";
import VueRouter from "vue-router";
/* import Home from "../views/Home.vue"; */
import Form from "../views/Form.vue";
import NotFound from "../views/404.vue";
import ThankYou from "../views/ThankYou.vue";
import UserTemplateForm from "../views/UserTemplateForm.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/:org/user/:code",
		name: "UserTemplateForm",
		component: UserTemplateForm
	},
	{
		path: "/:org/:entity/:lang?",
		name: "Form",
		component: Form
	},
	{
		path: "/thankyou/:lang?",
		name: "ThankYou",
		component: ThankYou
	},
	//{
	//	path: "/about",
	//	name: "About",
	//	// route level code-splitting
	//	// this generates a separate chunk (about.[hash].js) for this route
	//	// which is lazy-loaded when the route is visited.
	//	component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
	//},
	{
		path: "*",
		name: "404",
		component: NotFound
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

export default router;
